import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";

export class StaffController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	getEmployeeById = this.api.staff.employeeDetailById;
	getOwnEmployee = this.api.own.staffEmployeeListByRequest;
}
